/*
 * @Descripttion: 
 * @version: 
 * @Author: chenlongad
 * @Date: 2021-01-13 15:30:38
 * @LastEditors: chenlongad
 * @LastEditTime: 2021-03-17 09:44:47
 */
import { tApi, User } from 'tplus-api';
import { localStore } from 'mutants-microfx';
import { xlsky, xlssrt, tplusWebAppApiHost, tplusWebAppApiHost_test } from '../const/app';
import axios from 'axios';

export default class StoreApi{

    static async getStoreInfos(){
        const resp = await tApi({},'chanjet.RE.NewPos.QueryStoreInfo',false,false);
        return resp;
    }

    static async posLogin(param){
        const resp = await tApi(param,'chanjet.RE.NewPos.RegisterOrLoginPOS',false,false);
        return resp;
    }

    //pos的初始化方法
    static async posInit(){
        const resp = await tApi({},'chanjet.RE.NewPos.GetInitData',false,false);
        return resp;
    }

    //查询云端pos信息
    static async queryCloudPos(poskey = '', env = '') {
      const rep = localStore && localStore.get('recordEnvironmentParams');
      const baseURL = (rep === 'dev' || rep === 'test' || rep === 'inte') ? tplusWebAppApiHost_test : tplusWebAppApiHost;
      const ajax = axios.create({
        baseURL: baseURL
      });
      const ts = new Date().getTime();
      let sign = User.pwdEncrypt(`${atob(xlsky)}${ts}${atob(xlssrt)}`);
      const resp = await ajax.get(`pos/query?poskey=${poskey}&env=${env}`, {
        headers: {
          appkey: atob(xlsky),
          ts,
          sign
        }
      });
      return resp;
    }

    //pos更新检测
    static async posUpgrade() {
      return await tApi({}, 'chanjet.RE.NewPos.CheckTplusNeedUpgrade',false,false);
    }

    // 获取体验pos信息
    static async getDemoPosInfo() {
      return await tApi({}, 'chanjet.RE.NewPos.GetStoreAndPosInfo',false,false);
    }

    // 获取体验账号
    static async getDemoUser() {
      const demoUrl = ''; // test: intei-  prod: '';
      const url = `https://${demoUrl}t.chanjet.com/tplus/tplus/api/rest?IsFree=1&methodName=Ufida.T.SM.Login.Interface.ILogin.GetOneDemoUser`;
      const param = { Args: { industryCode: 'common', roleCode: '009', tel: '' }, Method: 'Ufida.T.SM.Login.Interface.ILogin.GetOneDemoUser' };
      const qs = JSON.stringify(param);
      return await axios.post(url, `Apis=${qs}`);
    }

    static async unregister(info = {}) {
      const rep = localStore && localStore.get('recordEnvironmentParams');
      const baseURL = (rep === 'dev' || rep === 'test' || rep === 'inte') ? tplusWebAppApiHost_test : tplusWebAppApiHost;
      const { AccountNum, OrgId, PosCode, PosKey: posKey } = info;
      const ajax = axios.create({
        baseURL: baseURL
      });
      const ts = new Date().getTime();
      let sign = User.pwdEncrypt(`${atob(xlsky)}${ts}${atob(xlssrt)}`);
      const resp = await ajax({
        method: 'POST',
        url: 'pos/UnregisterByKey',
        data: { posKey },
        headers: {
          appkey: atob(xlsky),
          ts,
          sign
        }
      });

      return resp;
    }
}
